import { api } from '@/api'
import type { Network, NetworkInput, NetworkResponse, NetworksResponse } from '../types'

// GET /bff/networks → { networks }.
export function listNetworks(): Promise<Network[]> {
  return api.get<NetworksResponse>('/networks').then((data) => data.networks)
}

// POST /bff/networks → { network }. (The mobile unwrapped `data.networks` here
// by mistake — the register response is the singular { network }.)
export function registerNetwork(input: NetworkInput): Promise<Network> {
  return api.post<NetworkResponse>('/networks', { body: input }).then((data) => data.network)
}

// GET /bff/networks/{id} → { network }.
export function getNetwork(id: string): Promise<Network> {
  return api.get<NetworkResponse>(`/networks/${id}`).then((data) => data.network)
}

// PUT /bff/networks/{id} → { network }.
export function updateNetwork(id: string, input: NetworkInput): Promise<Network> {
  return api.put<NetworkResponse>(`/networks/${id}`, { body: input }).then((data) => data.network)
}

// DELETE /bff/networks/{id} → { network }.
export function deleteNetwork(id: string): Promise<Network> {
  return api.delete<NetworkResponse>(`/networks/${id}`).then((data) => data.network)
}
